import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=a0c05a20&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=a0c05a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c05a20",
  null
  
)

export default component.exports